var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"py-2",attrs:{"role":"list"}},_vm._l((_vm.articles),function(article){return _c('article-list-item',{key:article.slug,attrs:{"link":article.link,"title":article.title},on:{"click":_vm.onClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }